module.exports = __webpack_public_path__ + "img/Landowner.581a848b.png";